.root {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  background: var(--md-surface-container-low);
  border-radius: var(--shape-md);
  padding: var(--space-3);
  border: none;
  font: inherit;
  text-align: start;
  width: 100%;
}

.interactive {
  cursor: pointer;
  transition: box-shadow var(--motion-duration-short3) ease;
}

.interactive:hover {
  box-shadow: var(--elevation-1);
}

@media (prefers-reduced-motion: reduce) {
  .interactive {
    transition: none;
  }
}

.dateMedallion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 52px;
  min-width: 52px;
  height: 52px;
  background: var(--md-surface-container-lowest);
  border-radius: var(--shape-sm);
}

.month {
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  font-weight: 700;
  color: var(--md-error);
}

.day {
  font: var(--type-title-lg);
  letter-spacing: var(--tracking-title-lg);
  font-weight: 700;
  color: var(--text);
}

.info {
  min-width: 0;
}

.title {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-weight: 600;
  color: var(--text);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.subtitle {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--text-light);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
